require('../scss/front.scss')
require('../scss/front/carousel.scss')
// require('@npm/flickity/dist/flickity.css');

import $ from 'jquery'
import jQuery from 'jquery'
import ListBox from './front/listbox'
import ContactMap from './front/contactmap'
import ProjectDetail from './front/projectdetail'
import Lightbox from './front/lightbox'
import UserCollection from './front/collection'
import initOpendaysBox from './front/openday'
import ImagesLoaded from 'imagesloaded'

window.googleMapsLoaded = false;
window.initMap = function () {
    window.googleMapsLoaded = true
}

window.$ = $
window.jQuery = jQuery
require('../scss/loader.scss');
require('./front/loader.jsx')
require('./front/cookies.js')
require('./front/polyfill.includes.js')
require('@npm/bootstrap/js/transition.js')
require('@npm/bootstrap/js/carousel.js')
require('@npm/bootstrap/js/tooltip.js')
require('@npm/jquery-validation/dist/jquery.validate.js')

jQuery(document).ready(function ($) {
    initCookies()
    $.validator.addMethod("city", function (value, element, param) {
        if ($(param).val().length > 0)
            return true
        else
            return false
    }, "Please specify a city selecting from the list of autocomplete");
    // http://jqueryvalidation.org/equalTo-method/
    $.validator.addMethod("pwequal", function (value, element, param) {
        return value == $('#nsecond').val()
    }, "Password fields are different")

    if ($('html').attr('lang') == 'it') {
        $.extend($.validator.messages, {
            required: "Campo obbligatorio",
            remote: "Controlla questo campo",
            email: "Inserisci un indirizzo email valido",
            url: "Inserisci un indirizzo web valido",
            date: "Inserisci una data valida",
            dateISO: "Inserisci una data valida (ISO)",
            number: "Inserisci un numero valido",
            digits: "Inserisci solo numeri",
            creditcard: "Inserisci un numero di carta di credito valido",
            equalTo: "Il valore non corrisponde {0} {1}",
            extension: "Inserisci un valore con un&apos;estensione valida",
            maxlength: $.validator.format("Non inserire pi&ugrave; di {0} caratteri"),
            minlength: $.validator.format("Inserisci almeno {0} caratteri"),
            rangelength: $.validator.format("Inserisci un valore compreso tra {0} e {1} caratteri"),
            range: $.validator.format("Inserisci un valore compreso tra {0} e {1}"),
            max: $.validator.format("Inserisci un valore minore o uguale a {0}"),
            min: $.validator.format("Inserisci un valore maggiore o uguale a {0}"),
            nifES: "Inserisci un NIF valido",
            nieES: "Inserisci un NIE valido",
            cifES: "Inserisci un CIF valido",
            currency: "Inserisci una valuta valida",
            city: "Specifica il nome di una città selezionandolo dall'elenco di autocompletamento",
            pwequal: "Le due password non coincidono"
        });
    }

    $.ajax({
        url: "https://maps.googleapis.com/maps/api/js?libraries=places&sensor=false&callback=initMap&key=AIzaSyCiK3Aon1Bn3KSmKnLmpw_lZxD3fgs0lZc",
        dataType: "script",
        cache: true
    });
    $('#nlpopbox').data('popbox', 'newsletter')
    $('body').on('click', 'a[data-toggle=loginredirect]', function (e) {
        e.preventDefault()
        window.location.href = $(this).attr('href') + '?redirect=' + escape(window.location.href);
    });
    initSvgConvert()
    initHeaderScroll()
    initBoxSearch()
    initBoxLogin()
    initBoxMobMenu()
    $('[data-toggle="tooltip"],[data-togglebis="tooltip"]').tooltip({container: 'body'});
    if ($('.box-projects').length) {
        $('.carousel').carousel()
        initTimeline()
        initBoxProjects()
        initHomeWidget()
    }
    if ($('#listbox').length) {
        ListBox($)
    }
    if ($('#page-map').length) {
        ContactMap($)
    }
    if ($('#project-detail').length) {
        ProjectDetail($)
    }
    if ($('#collection-results').length) {
        UserCollection($)
    }
    // if ($('#opendayspopup').length) {
    //     OpendaysPopup()
    // }
    Lightbox()
    ShareButtons()

    // $('.top-thumbs-more').click(function (e) {
    //     e.preventDefault()
    //     $('.listbox-items.top-thumbs li.active.hidden')
    //         .slice(0, $('.listbox-items.top-thumbs').data('limit'))
    //         .removeClass('hidden')
    //         .fadeIn()
    //     if (!$('.listbox-items.top-thumbs li.active.hidden').length)
    //         $('.top-thumbs-more-container').remove()
    // });
    if ($('#loginerror').length) {
        $('button[data-popbox="login"]').click();
        $('#login-error-area').html($('#loginerror'))
        $('a.close').click(function () {
            window.location.href = document.referrer;
            return false;
        })
    }
});

function initCookies() {
    COOKIES_ENABLER.init({})
}

function initTimeline() {
    let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    if(isIE11){
        $('.timeline.hide-smart').hide();
        $('.timeline-toggler.hide-desk').attr('style', 'display: block !important');
        return;
    }
    var $gal = $($("div.timeline").get(0)),
        galW = $gal.outerWidth(true),
        galSW = $gal[0].scrollWidth,
        wDiff = (galSW / galW) - 1,  // widths difference ratio
        mPadd = 10,  // Mousemove Padding
        damp = 10,  // Mousemove response softness
        mX = 0,   // Real mouse position
        mX2 = 0,   // Modified mouse position
        posX = 0,
        mmAA = galW - (mPadd * 2), // The mousemove available area
        mmAAr = (galW / mmAA);    // get available mousemove fidderence ratio
    var refreshInterval;
    $gal
        .mouseenter(function () {
            refreshInterval = setInterval(function () {
                posX += (mX2 - posX) / damp; // zeno's paradox equation "catching delay"
                $gal.scrollLeft(posX * wDiff);
            }, 10);
        })
        .mousemove(function (e) {
            mX = e.pageX - $(this).parent().offset().left - this.offsetLeft;
            mX2 = Math.min(Math.max(0, mX - mPadd), mmAA) * mmAAr;
        })
        .mouseleave(function () {
            clearInterval(refreshInterval);
        });
}

function initBoxProjects() {
    function showYear(year) {
        boxProjects.showInner('.projects')
        $('.y').hide()
        $('.y[data-year="' + year + '"]').fadeIn()
        $('#box-years .item.active').removeClass('active')
        $('#box-years .item[data-year="' + year + '"]').addClass('active')
    }

    var boxProjects = initBox('.box-projects')
    $('.timeline a').click(function () {
        showYear($(this).text())
        return false;
    }).hover(function () {
        $(this).parent().prev().find('a').addClass('hov')
        $(this).parent().next().find('a').addClass('hov')
    }, function () {
        $(this).parent().prev().find('a').removeClass('hov')
        $(this).parent().next().find('a').removeClass('hov')
    })
    $('[data-toggle="timeline"]').click(function () {
        showYear($(this).data('year'))
    })
    $('#box-years').bind('slid.bs.carousel', function (e) {
        setTimeout(function () {
            let y = $('#box-years .item.active').data('year');
            $('.y').hide()
            $('.y[data-year="' + y + '"]').show()
        }, 100)
    });
}
// function initMobMenu($) {
//     $('.btn-mob-menu').click(function () {
//         $(this).toggleClass('open');
//         $('#box-mob-menu').removeClass('hidden').toggle();
//     });
// }
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function initBoxLogin() {
    var boxLogin = initBox('.box-login');

    function initAjaxBoxForm(selector, successCallback) {
        if (!$(selector).length)
            return;
        let form = $(selector)
        form.validate({
            focusInvalid: true,
            ignore: "",
            onfocusout: function (element) {
                setTimeout(() => $(element).valid(), 500);
            }
        })

        form.submit(function () {
            if (!form.valid())
                return false;
            let btn = form.find('button[type=submit]')
            let old = btn.text()
            btn.text(btn.data('loadingtext') ? btn.data('loadingtext') : 'Caricamento...').attr('disabled', true)
            if (form.parent().hasClass('direct'))
                return true;
            $.post(
                form.attr('action'),
                form.serialize(),
                function (data) {
                    if (data.has_error) {
                        form.find('.error-area').html('<div class="error">' + data.error + '</div>')
                        btn.text(old).attr('disabled', false)
                    } else {
                        successCallback(form, data)
                    }
                }
            );
            return false;
        });
    }

    function init() {
        $('a#nlpopbox, [data-popbox]').click(function (e) {
            e.preventDefault()
            boxLogin.showInner('.' + $(this).data('popbox'))
            if ($(this).data('popbox') == 'collection') {
                initCollectionBox($(this))
            }
            if ($(this).data('popbox') == 'opendays') {
                initOpendaysBox($(this))
            }
            return false
        })
        let int = setInterval(() => {
            if (!window.googleMapsLoaded) return

            $('.placeselect').each(function () {
                let prefix = $(this).data('prefix')
                let autocomplete = new google.maps.places.Autocomplete(this);
                autocomplete.setTypes(['(cities)']);
                autocomplete.addListener('place_changed', function () {
                    var place = autocomplete.getPlace();
                    if (!place.geometry) {
                        // User entered the name of a Place that was not suggested and
                        // pressed the Enter key, or the Place Details request failed.
                        window.alert("No details available for input: '" + place.name + "'");
                        return;
                    } else {
                        let address = '';
                        if (place.address_components) {

                            $(prefix + 'lat').val(place.geometry.location.lat());
                            $(prefix + 'lng').val(place.geometry.location.lng());
                            $(prefix + 'country').val(findComponent(place, 'country'));
                            $(prefix + 'state').val(findComponent(place, 'administrative_area_level_1'));
                            $(prefix + 'province').val(findComponent(place, 'administrative_area_level_2'));
                            $(prefix + 'city').val(findComponent(place, 'administrative_area_level_3') || findComponent(place, 'locality'));
                            $(prefix + 'gid').val(place.id);
                        }
                    }
                })
            })
            clearInterval(int)
        }, 300);

        initAjaxBoxForm('.inner.login form', function (form) {
            let redirect = getParameterByName('redirect')
            window.location.href = redirect ? redirect : '/'
        });
        let defaultCallback = function (form) {
            form.find('.hide-on-success').hide();
            form.find('.show-on-success').fadeIn();
        }
        initAjaxBoxForm('.inner.newsletter form', defaultCallback);
        initAjaxBoxForm('.inner.register form', function (form, data) {
            let boxLogin = $('.box-login');
            boxLogin.on('popbox.close', function () {
                if (success)
                    location.reload()
            })
            defaultCallback(form, data)
        });
        initAjaxBoxForm('.inner.recover form', defaultCallback);
        initAjaxBoxForm('.inner.collection form', function (form, data) {
            defaultCallback(form)
            if (data.new_collection) {
                $('#collection-id').append($('<option value="' + data.new_collection_id + '">' + data.new_collection_text + '</option>'));
            }
        });

        if ($('#edit-profile').length) {
            initAjaxBoxForm('form#edit-profile', defaultCallback);
            initAjaxBoxForm('form#edit-password', defaultCallback);
        }
    }

    function initCollectionBox(button) {
        $('#collection-image-id').val(button.data('id'))
        $('#collection-image-type').val(button.data('type'))
        let boxLogin = $('.box-login');
        if (!boxLogin.hasClass('collectionloaded')) {
            boxLogin.on('popbox.close', function () {
                setTimeout(function () {
                    $('#collection-id').val('new').change()
                    $('#collection-name').val('')
                    let form = boxLogin.find('.inner.collection form')
                    form.find('.hide-on-success').fadeIn()
                    form.find('.show-on-success').hide()
                    let btn = form.find('button')
                    btn.text(btn.data('submittext')).attr('disabled', false)
                }, 500)
            })
            $('#collection-id').change(function () {
                let isNew = $(this).val() == 'new'
                $('#collection-name-box').toggle(isNew)
                $('#collection-name').attr('required', isNew)
            }).change();
            boxLogin.addClass('collectionloaded')
        }
    }

    init()
    return boxLogin;
}

function initBox(box_selector) {
    var ret = {
        box: $(box_selector),
        open: function () {
            if (!this.box.hasClass('open')) {
                this.box.trigger("popbox.open")
                this.box.addClass('open').fadeIn()
            }
            return this
        },
        close: function () {
            this.box.removeClass('open').fadeOut()
            return this
        },
        showInner: function (selector) {
            this.box.find('.inner').removeClass('open').hide()
            var o = this.box.find(selector).addClass('open')
            if (this.box.hasClass('open'))
                o.fadeIn();
            else
                o.show();
            this.open();
            return this
        },
        init: function () {
            var self = this;
            $(this.box.find('.close, .close2')).click(function (e) {
                if (!$(this).hasClass('default')) {
                    e.preventDefault()
                    e.stopPropagation()
                    self.close()
                    self.box.trigger("popbox.close")
                    return false
                }
            })
            $(document).keyup(function (e) {
                if (self.box.hasClass('open') && e.keyCode === 27) {
                    self.box.find('.close').click()
                }
            })
        }
    }
    ret.init()
    return ret
}

function initHomeWidget() {
    function alignWidgets() {
        if ($(window).width() <= 750) {
            $('.widget').css('margin-top', 0)
        } else {
            $('.widget').each(function () {
                let widget = $(this)
                let h = 0;
                if (widget.hasClass('of-right')) {
                    h = $(this).next('.widget').height()
                } else if (widget.hasClass('of-left')) {
                    h = $(this).prev('.widget').height()
                } else {
                    return;
                }
                let wh = widget.height()
                if (widget.hasClass('middle')) {
                    h = (h - wh) / 2
                } else if (widget.hasClass('bottom')) {
                    h = h - wh
                } else {
                    h = 0
                }
                widget.css('margin-top', h)
            });
        }
    }

    $('.widget a.plus, .widget img').click(function (e) {
        $(this).closest('.widget')
            .find('.inner')
            .toggleClass('open')
        return false
    });
    $(window).resize(alignWidgets)
    alignWidgets()
    setTimeout(function () {
        let selector = '.home-widget';
        ImagesLoaded(document.querySelector(selector), function () {
            $(selector)
                .hide()
                .removeClass('loading')
                .addClass('loaded')
                .fadeIn()
                .find('.loader')
                .remove()
        })
    }, 100)
}

function initHeaderScroll() {
    var h = $("header")
    var b = $("body")
    $(document).on("scroll", function () {
        if ($(document).scrollTop() > 100) {
            h.removeClass("large").addClass("small")
            b.removeClass("header-large").addClass("header-small")
            b.css('padding-top', h.height())
        } else {
            h.removeClass("small").addClass("large")
            b.removeClass("header-small").addClass("header-large")
            b.css('padding-top', 0)
        }
    })
}

function initBoxSearch() {
    $('.btn-search').click(function (e) {
        $('#box-search,.btn-search a, .btn-search').toggleClass('open')
        return false
    });
}
function initBoxMobMenu() {
    $('#btn-mob-menu').click(function (e) {
        $('#box-mob-menu,#btn-mob-menu a, #btn-mob-menu').toggleClass('open')
        if ($('#box-mob-menu').hasClass('open'))
            setTimeout(function () {
                $('#box-mob-menu > ul').addClass('open')
            }, 200);
        else
            $('#box-mob-menu > ul').removeClass('open')
        return false
    });
    $('#box-mob-menu li.dropdown').click(function () {
        $(this).toggleClass('hover')
    });
}

function initSvgConvert() {
    $('img.svg-convert').each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');

    });
}

if (!Array.prototype.includes) {
    Array.prototype.includes = function() {
        'use strict';
        return Array.prototype.indexOf.apply(this, arguments) !== -1;
    };
}

function findComponent(result, type) {
    let component = result.address_components.find(function (component) {
        return component.types.includes(type)
    });
    return component && component.short_name
}

function ShareButtons() {
    $('.share2').click(function (e) {
        e.preventDefault()
        $(this).parent().toggleClass('open')
    })
    $('[data-toggle=socials]').click(function (e) {
        e.preventDefault()
        let url = escape($(this).parent().data('url') ? $(this).parent().data('url') : window.location.href)
        if ($(this).hasClass('facebook')) {
            window.open("https://www.facebook.com/sharer/sharer.php?u=" + url, "pop", "width=600, height=400, scrollbars=no");
        } else if ($(this).hasClass('twitter')) {
            window.open("http://twitter.com/intent/tweet?url=" + url, "pop", "width=600, height=400, scrollbars=no")
        } else if ($(this).hasClass('google-plus')) {
            window.open('https://plus.google.com/share?url=' + url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600')
        }
    });
}


// WEBPACK FOOTER //
// ./app/Resources/assets/js/front.jsx